<header *ngIf="isMedium || isLarge" id="main-header">
  <dx-toolbar
    class="header-toolbar"
    [ngClass]="menuToggle ? 'menu-opened-width' : 'menu-colapesed-width'"
  >
    <dxi-item
      *ngIf="auth0.loggedIn && isBuyer"
      location="left"
      locateInMenu="auto"
    >
      <div *dxTemplate>
        <app-search-panel></app-search-panel>
      </div>
    </dxi-item>

    <dxi-item
      *ngIf="auth0.loggedIn && isBuyer"
      location="after"
      locateInMenu="auto"
      width="200"
    >
      <div *dxTemplate="let data of 'content'">
        <app-switch-facilities
          mode="topNav"
          (click)="openedSwitchFacility()"
        ></app-switch-facilities>
      </div>
    </dxi-item>

    <dxi-item
      *ngIf="auth0.loggedIn"
      location="after"
      locateInMenu="auto"
      menuItemTemplate="menuItem"
    >
      <div *dxTemplate="let data of 'item'">
        <dx-button
          class="user-button authorization"
          height="100%"
          stylingMode="text"
        >
          <div *dxTemplate="let data of 'content'">
            <app-user-panel
              [menuItems]="userMenuItems"
              menuMode="context"
            ></app-user-panel>
          </div>
        </dx-button>
      </div>
    </dxi-item>

    <div *dxTemplate="let data of 'menuItem'">
      <app-user-panel
        [menuItems]="userMenuItems"
        menuMode="list"
      ></app-user-panel>
    </div>

    <dxi-item
      *ngIf="auth0.loggedIn && isBuyer && !hydraEnabled"
      location="after"
      locateInMenu="auto"
    >
      <div *dxTemplate>
        <app-facility-and-user-stats
          [isHeaderButton]="true"
          (click)="openedStats()"
        ></app-facility-and-user-stats>
      </div>
    </dxi-item>

    <dxi-item *ngIf="auth0.loggedIn" location="after" locateInMenu="auto">
      <div *dxTemplate>
        <app-notifications
          [isBuyer]="isBuyer"
          [isSeller]="isSeller"
          (click)="openedNotifications()"
        ></app-notifications>
      </div>
    </dxi-item>

    <dxi-item
      *ngIf="auth0.loggedIn && isBuyer"
      location="after"
      locateInMenu="auto"
    >
      <div *dxTemplate>
        <app-cart-panel
          (cartToggle)="cartOpened = !cartOpened"
        ></app-cart-panel>
      </div>
    </dxi-item>

    <div *dxTemplate="let data of 'helpItem'">
      <app-help-dropdown-btn menuMode="list"></app-help-dropdown-btn>
    </div>

    <dxi-item
      *ngIf="isImpersonating"
      location="after"
      locateInMenu="auto"
      menuItemTemplate="helpItem"
    >
      <div *dxTemplate="let data of 'item'">User ID: {{ userId }}</div>
    </dxi-item>
    <dxi-item
      *ngIf="auth0.loggedIn && isImpersonating"
      location="after"
      locateInMenu="auto"
      menuItemTemplate="helpItem"
    >
      <div *dxTemplate="let data of 'item'">
        <dx-button
          stylingMode="text"
          icon="runner"
          (onClick)="unimpersonate()"
        ></dx-button>
      </div>
    </dxi-item>
  </dx-toolbar>
</header>

<header *ngIf="auth0.loggedIn && isSmall" id="main-header" class="shadow">
  <dx-toolbar
    class="header-toolbar"
    [multiline]="false"
    style="padding: 0px 12px 0 12px"
  >

    <dxi-item location="before" *ngIf="isSalesRepresentative">
      <div *dxTemplate>
        <div class="logo">
          <img [src]="largeLogo" [alt]="logoAltText" width="112" />
        </div>
      </div>
    </dxi-item>

    <dxi-item location="after" locateInMenu="auto" *ngIf="isBuyer && !isSalesRepresentative">
      <div *dxTemplate>
        <dx-button
          icon="pharmacies"
          (onClick)="goTo('/switch-facilities')"
          hint="Facilities"
          stylingMode="text"
        ></dx-button>
      </div>
    </dxi-item>

    <dxi-item location="after" locateInMenu="auto" *ngIf="!isSalesRepresentative">
      <div *dxTemplate>
        <dx-button
          icon="user"
          (onClick)="goTo('/user-profile')"
          hint="User Profile"
          stylingMode="text"
        ></dx-button>
      </div>
    </dxi-item>

    <dxi-item location="after" locateInMenu="auto">
      <div *dxTemplate>
        <dx-button
          icon="comment"
          (onClick)="openChat()"
          hint="Chat"
          stylingMode="text"
        ></dx-button>
      </div>
    </dxi-item>

    <dxi-item location="after" locateInMenu="auto">
      <div *dxTemplate>
        <dx-button
          icon="runner"
          (onClick)="auth0.logout()"
          hint="Logout"
          stylingMode="text"
        ></dx-button>
      </div>
    </dxi-item>
  </dx-toolbar>
</header>

<div
  *ngIf="auth0.loggedIn && isBuyer"
  id="cartSidenav"
  class="sidenav bg-lightgray shadow dx-base-backgorund"
  [ngClass]="cartOpened ? 'cart-show' : 'cart-hide'"
>
  <app-cart-side mode="sidebar" (visibleOut)="closeCar($event)"></app-cart-side>
</div>

<dx-popup
  *ngIf="isDocumentUploadOpen"
  [showTitle]="true"
  title="{{ documentUploadPopupTitle }}"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="isDocumentUploadOpen"
  [width]="documentUploadPopupWidth"
  [height]="800"
>
  <dx-tab-panel
    #tabPanel
    [height]="'91%'"
    [dataSource]="tabs"
    [selectedIndex]="0"
    [loop]="false"
    [animationEnabled]="true"
    [swipeEnabled]="true"
  >
    <div *dxTemplate="let x of 'stateLicenseTemplate'" class="mt-2">
      <app-document-upload
        [showDelete]="true"
        context="facility"
        [companyId]="companyId"
        [facilityId]="facilityId"
        type="state_license"
        [updateLicenseinDB]="true"
      >
      </app-document-upload>
    </div>
    <div *dxTemplate="let x of 'deaLicenseTemplate'" class="mt-2">
      <app-document-upload
        [showDelete]="true"
        context="facility"
        [companyId]="companyId"
        [facilityId]="facilityId"
        type="dea_license"
        [updateLicenseinDB]="true"
      >
      </app-document-upload>
    </div>
    <div *dxTemplate="let x of 'purchaseHistoryTemplate'" class="mt-2">
      <app-calibration-file-upload
        [facilityId]="facilityId"
        [companyId]="companyId"
      >
      </app-calibration-file-upload>
    </div>
  </dx-tab-panel>
    <div class="d-flex justify-content-end mt-4">
      <dx-button
          text="Close"
          (onClick)="isDocumentUploadOpen = false;"
          type="danger"
          icon="close"
          class="mr-2"
      ></dx-button>
  </div>
</dx-popup>

<dx-popup
  [showTitle]="true"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [width]="850"
  [height]="485"
  title="{{ user?.first_name }} {{ user?.last_name }}"
  [showCloseButton]="true"
  [(visible)]="isProfilePopupOpen"
  (hiding)="closingPopup()"
>
  <app-user-profile></app-user-profile>
</dx-popup>


<div class="bottom-navbar" *ngIf="auth0.loggedIn && isSmall && isAdmin">
  <div class="nav-item" [routerLink]="['/admin/user-manager']" routerLinkActive="active">
    <i class="dx-icon dx-icon-group"></i>
    <span>Users</span>
  </div>
  <div class="nav-item" [routerLink]="['/orders']" routerLinkActive="active">
    <i class="dx-icon dx-icon-orders"></i>
    <span>Orders</span>
  </div>
  <div class="nav-item home-button" [routerLink]="['/admin/home']" routerLinkActive="active">
    <i class="dx-icon dx-icon-home"></i>
    <span>Home</span>
  </div>
  <div class="nav-item" [routerLink]="['/admin/facility-manager']" routerLinkActive="active">
    <i class="dx-icon dx-icon-companies"></i>
    <span>Facilities</span>
  </div>
  <div class="nav-item" [routerLink]="['/mobile-menu']" routerLinkActive="active">
    <i class="dx-icon dx-icon-menu"></i>
    <span>Menu</span>
  </div>
</div>

<div class="bottom-navbar" *ngIf="auth0.loggedIn && isSmall && isBuyer && !isSalesRepresentative">
  <!-- <div class="nav-item" [routerLink]="['/switch-facilities']" routerLinkActive="active">
    <i class="dx-icon dx-icon-refresh"></i>
    <span>Switch</span>
  </div> -->
  <div class="nav-item" [routerLink]="['/catalog']" routerLinkActive="active">
    <i class="dx-icon dx-icon-catalogs"></i>
    <span>Catalog</span>
  </div>
  <div class="nav-item" [routerLink]="['/orders']" routerLinkActive="active">
    <i class="dx-icon dx-icon-orders"></i>
    <span>Orders</span>
  </div>
  <div class="nav-item home-button" [routerLink]="['/buyer-home']" routerLinkActive="active">
    <i class="dx-icon dx-icon-home"></i>
    <span>Home</span>
  </div>
  <div class="nav-item">
    <app-cart-panel
      (cartToggle)="cartOpened = !cartOpened"
    ></app-cart-panel>
    <span>Cart</span>
  </div>
  <div class="nav-item" [routerLink]="['/mobile-menu']" routerLinkActive="active">
      <i class="dx-icon dx-icon-menu"></i>
      <span>Menu</span>
  </div>
</div>


<div class="bottom-navbar" *ngIf="auth0.loggedIn && isSmall && isSalesRepresentative">
  <div class="nav-item" [routerLink]="['/catalog']" routerLinkActive="active">
    <i class="dx-icon dx-icon-catalogs"></i>
    <span>Place Order</span>
  </div>
  <div class="nav-item" [routerLink]="['/orders']" routerLinkActive="active">
    <i class="dx-icon dx-icon-orders"></i>
    <span>Past Orders</span>
  </div>
  <div class="nav-item home-button" [routerLink]="['/switch-facilities']" routerLinkActive="active">
    <i class="dx-icon dx-icon-home"></i>
    <span>Select Facility</span>
  </div>
  <div class="nav-item">
    <app-cart-panel
      (cartToggle)="cartOpened = !cartOpened"
    ></app-cart-panel>
    <span>Cart</span>
  </div>
  <div class="nav-item" [routerLink]="['/mobile-menu']" routerLinkActive="active">
      <i class="dx-icon dx-icon-menu"></i>
      <span>Menu</span>
  </div>
</div>
